class BaseRender {
  render() {
    // Override in subclass
  }
}

export { BaseRender };
